export const bankList = [
  {
    id: "Bank of Africa (BOA)",
    label: "Bank of Africa (BOA)",
    code: "BOA",
    countries: ["SN", "CI", "BJ", "BF", "ML", "NE", "TG"],
  },
  {
    id: "Banque Atlantique",
    label: "Banque Atlantique",
    code: "ATLANTIQUE",
    countries: ["CI", "BJ", "BF", "ML", "NE", "TG"],
  },
  {
    id: "Banque de Dakar",
    label: "Banque de Dakar",
    code: "BDK",
    countries: ["SN"],
  },
  {
    id: "Banque de l'Habitat du Sénégal",
    label: "Banque de l'Habitat du Sénégal",
    code: "BHS",
    countries: ["SN"],
  },
  {
    id: "Banque d’Abidjan",
    label: "Banque d’Abidjan",
    code: "BDA",
    countries: ["CI"],
  },
  {
    id: "Banque Nationale de Développement Économique",
    label: "Banque Nationale de Développement Économique",
    code: "BNDE",
    countries: ["SN"],
  },
  {
    id: "BGFIBank",
    label: "BGFIBank",
    code: "BGFI",
    countries: ["SN", "CI", "BJ"],
  },
  {
    id: "BSIC",
    label: "BSIC",
    code: "BSIC",
    countries: ["SN", "CI", "BJ", "BF", "ML", "NE", "TG"],
  },
  {
    id: "Bridge Bank Group",
    label: "Bridge Bank Group",
    code: "BRIDGE",
    countries: ["CI"],
  },
  {
    id: "CBAO Groupe Attijariwafa Bank",
    label: "CBAO Groupe Attijariwafa Bank",
    code: "CBAO",
    countries: ["SN"],
  },
  {
    id: "Coris Bank International",
    label: "Coris Bank International",
    code: "CORIS",
    countries: ["BF", "CI", "SN", "ML", "TG"],
  },
  {
    id: "Crédit Mutuel du Sénégal",
    label: "Crédit Mutuel du Sénégal",
    code: "CDS",
    countries: ["SN"],
  },
  {
    id: "Ecobank",
    label: "Ecobank",
    code: "ECOBANK",
    countries: ["SN", "CI", "BJ", "BF", "ML", "NE", "TG", "GW"],
  },
  { id: "FBNBank", label: "FBNBank", code: "FBN", countries: ["SN", "CI"] },
  {
    id: "NSIA Banque",
    label: "NSIA Banque",
    code: "NSIA",
    countries: ["CI", "BJ", "SN"],
  },
  {
    id: "Orange Bank Africa",
    label: "Orange Bank Africa",
    code: "ORANGE_BANK",
    countries: ["CI", "SN"],
  },
  {
    id: "Orabank",
    label: "Orabank",
    code: "ORABANK",
    countries: ["SN", "CI", "BJ", "BF", "ML", "NE", "TG", "GW"],
  },
  {
    id: "Société Générale",
    label: "Société Générale",
    code: "SG",
    countries: ["SN", "CI", "BJ", "BF"],
  },
  {
    id: "United Bank for Africa",
    label: "United Bank for Africa",
    code: "UBA",
    countries: ["SN", "CI", "BF", "ML", "NE", "TG"],
  },
  {
    id: "Versus Bank",
    label: "Versus Bank",
    code: "VERSUS",
    countries: ["CI"],
  },
  { id: "Autre banque", label: "Autre banque", code: "OTHER", countries: [] },
];
